import { z } from "zod";
import { cbHttp } from "./http.service"
import { FtpSchema } from "@/schemas/ftp.schema";

export const getFTPConnections = async (): Promise<z.infer<typeof FtpSchema>[]> => {
    return cbHttp.get("/api/ftpconnection/connections");
}

export const createConnection = async (data: FormData): Promise<string> => {
    return cbHttp.post("/api/ftpconnection/createconnection", data);
}

export const editConnection = async (data: FormData): Promise<string> => {
    return cbHttp.post("/api/ftpconnection/editconnection", data);
}

export const deleteConnection = async (data: FormData): Promise<string> => {
    return cbHttp.post("/api/ftpconnection/deleteconnection", data);
}

export const getApprovedConnections = async (): Promise<z.infer<typeof FtpSchema>[]> => {
    return cbHttp.get("/api/ftpconnection/approvedconnections");
}
